import { Accordion, AccordionSummary, AccordionDetails, Typography, Grid } from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { Trans, t } from '@lingui/macro'
import DateRangePickerInput from '@/components/ui/inputs/DateRangePickerInput'
import WeeklyConsultationsByDayComponent from './charts/WeeklyConsultationsByDayComponent'
import WeeklyConsultationsBySpecialtyComponent from './charts/WeeklyConsultationsBySpecialtyComponent'
import WeeklyConsultationsByTypeComponent from './charts/WeeklyConsultationsByTypeComponent'
import DailyConsultationsByUserComponent from './charts/DailyConsultationsByUserComponent'
import DailyExpertisesByUserComponent from './charts/DailyExpertisesByUserComponent'
import DailyExpertisesByStatusComponent from './charts/DailyExpertisesByStatusComponent'

type WeeklySectionProps = {
  isExpanded: boolean
  onChange: (event: React.SyntheticEvent, isExpanded: boolean) => void
  selectedRange: [Date, Date]
  onRangeChange: (range: { start: Date | null; end: Date | null }) => void
  establishmentId: string
  weeklyConsultationsData: any
  weeklySpecialtyData: any
  weeklyConsultationsByTypeData: any
  isMobile: boolean
}

export function WeeklySection({
  isExpanded,
  onChange,
  selectedRange,
  onRangeChange,
  establishmentId,
  weeklyConsultationsData,
  weeklySpecialtyData,
  weeklyConsultationsByTypeData,
  isMobile,
}: WeeklySectionProps) {
  return (
    <Accordion
      expanded={isExpanded}
      onChange={onChange}
      TransitionProps={{ unmountOnExit: false }}
      sx={{
        '& .MuiAccordionSummary-content': {
          margin: isMobile ? '10px 0' : undefined,
        },
      }}
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="weekly-content" id="weekly-header">
        <Typography variant="h6" sx={{ fontSize: isMobile ? '1rem' : undefined }}>
          <Trans>Weekly</Trans>
        </Typography>
      </AccordionSummary>
      <AccordionDetails sx={{ p: isMobile ? 1 : 2 }}>
        <Grid container spacing={isMobile ? 2 : 3}>
          <Grid item xs={12}>
            <DateRangePickerInput
              value={selectedRange}
              onChange={onRangeChange}
              label={t`Select Date Range`}
              sx={{
                width: '100%',
                '& .MuiInputBase-input': {
                  fontSize: isMobile ? '0.875rem' : undefined,
                },
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <WeeklyConsultationsByDayComponent data={weeklyConsultationsData} title={t`Consultations by Day`} />
          </Grid>
          <Grid item xs={12}>
            <WeeklyConsultationsBySpecialtyComponent data={weeklySpecialtyData} title={t`Consultations by Specialty`} />
          </Grid>
          <Grid item xs={12}>
            <WeeklyConsultationsByTypeComponent data={weeklyConsultationsByTypeData} title={t`Consultations by Type`} />
          </Grid>
          <Grid item xs={12}>
            <DailyConsultationsByUserComponent
              establishmentId={establishmentId}
              title={t`Consultations by User`}
              startDate={selectedRange[0]}
              endDate={selectedRange[1]}
            />
          </Grid>
          <Grid item xs={12}>
            <DailyExpertisesByUserComponent
              establishmentId={establishmentId}
              title={t`Expertises by User`}
              startDate={selectedRange[0]}
              endDate={selectedRange[1]}
            />
          </Grid>
          <Grid item xs={12}>
            <DailyExpertisesByStatusComponent
              establishmentId={establishmentId}
              title={t`Expertises by Status`}
              startDate={selectedRange[0]}
              endDate={selectedRange[1]}
            />
          </Grid>
        </Grid>
      </AccordionDetails>
    </Accordion>
  )
}
